import { jwtDecode } from "jwt-decode";
import { type FoojiData } from "../../../../types/campaign";

export type JwtPayload = {
  exp: number;
  via: string;
  fooji_data: FoojiData;
  is_temp?: boolean;
  identifier?: string;
  temp_data?: {
    fooji_data: FoojiData;
  };
};

export const decodeJWT = (jwt: string) => jwtDecode<JwtPayload>(jwt);
